import { ComponentType } from 'react';
import { StepId } from './types';
import {
  MatcherServicesStep,
  MatcherBusinessStep,
  MatcherEntityStep,
  MatcherIndustryStep,
  MatcherProblemStep,
  MatcherPlanStep,
  MatcherMeetingStep,
  MatcherLocationStep,
  MatcherSearchStep,
  MatcherNameStep,
  MatcherPhoneStep,
  MatcherVerificationStep,
  MatcherEmailStep,
  MatcherQuestionStep,
  MatcherFileStep
} from '../steps';

export const STEP_COMPONENTS: Record<StepId, ComponentType> = {
  services: MatcherServicesStep,
  business: MatcherBusinessStep,
  entity: MatcherEntityStep,
  industry: MatcherIndustryStep,
  problem: MatcherProblemStep,
  plan: MatcherPlanStep,
  meeting: MatcherMeetingStep,
  location: MatcherLocationStep,
  search: MatcherSearchStep,
  name: MatcherNameStep,
  phone: MatcherPhoneStep,
  verification: MatcherVerificationStep,
  email: MatcherEmailStep,
  question: MatcherQuestionStep,
  file: MatcherFileStep
};
